export const JWT_LOGIN = "/auth/login"

export const JWT_LOGOUT = "/auth/logout"

export const CHANGE_PASS = "/password/update"

export const REFRESH_TOKEN = "/auth/refreshToken"

export const CHANGE_PASS_VIA_EMAIL = "/password/reset"

export const VERIFY_2_MFA = "/auth/verify-2fa"
